<div class="col-md-12 noBottomMargin noPaddingMd-12" >
  <div class="col-md-12 noBottomMargin noPaddingMd-12 faqbanner">

  </div>
  <div class="col-md-12 faqBreadCrumbDiv">
    <ol class="breadcrumb">
      <li><a href="">{{ 'global.menu.home'|translate }}</a></li>
      <li><a href="" >{{ 'global.menu.information'|translate }}</a></li>
      <li class="active">FAQ</li>
    </ol>
  </div>
  <div class="col-md-12 faqBannerTextDiv">
  <div class="col-md-12 noPaddingMd-12 noBottomMargin">
    <div class="col-md-5 noPaddingMd-12"></div>
    <div class="col-md-2 centerTextdiv noPaddingMd-12"><h5 class="headerHeading1">{{ 'faq.title1'|translate }}</h5></div>
    <div class="col-md-5 noPaddingMd-12"></div>
  </div>
  <div class="col-md-12 noPaddingMd-12 noBottomMargin">
    <div class="col-md-3 noPaddingMd-12"></div>
    <div class="col-md-6 centerTextdiv objectiveDiv noPaddingMd-12"><h2 class="headerHeading2">{{purpose.title}}</h2></div>
    <div class="col-md-3 noPaddingMd-12"></div>
  </div>
  <div class="col-md-12 noPaddingMd-12 mainContDiv noBottomMargin" *ngIf="!emptyFaqData">
    <div class="col-md-3 noPaddingMd-12"></div>
    <div class="col-md-6 centerTextdiv noPaddingMd-12"><p class="faqHeaderContent">{{purpose.content}}</p></div>
    <div class="col-md-3 noPaddingMd-12"></div>
  </div>
  </div>
  <div class="col-md-12 noPaddingMd-12">
    <div class="col-md-3 noPaddingMd-12"></div>
    <div class="col-md-6 centerTextdiv noPaddingMd-12 "><h1 class="mainContentHeader">Frequently Asked Questions</h1></div>
    <div class="col-md-3 noPaddingMd-12"></div>
  </div>
  <div class="col-md-12 outerAccordion" *ngIf="!emptyFaqData">
  <div class="col-md-12 noPaddingMd-12 accordionDiv" >
    <div class="accordion js-accordion" role="tablist" aria-multiselectable="true">
      <div class="panel emplyPanel">

          &nbsp;
      </div>
      <div class="panel" *ngFor="let faq of faqs;let i = index;">
        <div class="accordion-panel-heading" data-toggle="collapse" data-parent=".js-accordion" [attr.data-target]="'.js-collapse-' + i"  role="tab">
          <p [innerHTML]="faq.question | sanitizeHtml" ></p>
        </div>
        <div class="{{ i === 0 ? 'accordion-panel-collapse collapse in js-collapse-' + i: 'accordion-panel-collapse collapse js-collapse-' + i}}" role="tabpanel">
          <div class="accordion-panel-body"><p [innerHTML]="faq.answer | sanitizeHtml" ></p></div>
        </div>
      </div>
      <div class="panel emptyPanel2">

        &nbsp;
      </div>
    </div>
  </div>
  </div>
  <div class="col-md-12 noBottomMargin alert alert-info centerTextdiv" *ngIf="emptyFaqData">{{'global.messages.info.nodata' | translate}}</div>
</div>


